import React from "react";
import './Three.css'
import buffet1 from "../../Pages/Gallery/Image/buffet1.png";
import buffet2 from "../../Pages/Gallery/Image/buffet2.png";
import buffet3 from "../../Pages/Gallery/Image/buffet3.png";
import buffet4 from "../../Pages/Gallery/Image/buffet4.png";
const ContentPhotoPostAi = () => {
  const photos = [
    { img: buffet1, label: "Slide 1" },
    { img: buffet2, label: "Slide 2" },
    { img: buffet3, label: "Slide 3" },
    { img: buffet4, label: "Slide 4" },
  ];

  return (
    <div className="text-white">
      <div className="text-center">
        <p className="postAI-title">
          <span className="fw-bold">Buffet Strategy</span>: Scanning all options before picking up a plate.
        </p>
        <div className="postAI-image">
          {photos.map((item, index) => (
            <div key={index}>
              <img src={item.img} alt={`Buffet ${index + 1}`} style={{ maxWidth: "100%", height: "auto" }} />
              <p className="mt-2 mb-4">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContentPhotoPostAi;
